import React from 'react';

const SectionSelector = ({ selectedSections, onChange }) => {
  const allSections = ['summary', 'experience', 'skills'];
  
  const handleSectionToggle = (section) => {
    if (selectedSections.includes(section)) {
      onChange(selectedSections.filter(s => s !== section));
    } else {
      onChange([...selectedSections, section]);
    }
  };
  
  const handleSelectAll = () => {
    onChange(selectedSections.length === allSections.length ? [] : allSections);
  };
  
  return (
    <div className="space-y-4">
      <div className="flex items-start">
        <div className="flex items-center h-5">
          <input
            id="polish-all"
            name="sections"
            type="checkbox"
            className="focus:ring-primary-500 h-4 w-4 text-primary-600 border-gray-300 rounded"
            checked={selectedSections.length === allSections.length}
            onChange={handleSelectAll}
          />
        </div>
        <div className="ml-3 text-sm">
          <label htmlFor="polish-all" className="font-medium text-gray-700">
            Select All
          </label>
          <p className="text-gray-500">
            Polish all sections of your resume
          </p>
        </div>
      </div>
      
      <div className="flex items-start">
        <div className="flex items-center h-5">
          <input
            id="polish-summary"
            name="sections"
            type="checkbox"
            className="focus:ring-primary-500 h-4 w-4 text-primary-600 border-gray-300 rounded"
            checked={selectedSections.includes('summary')}
            onChange={() => handleSectionToggle('summary')}
          />
        </div>
        <div className="ml-3 text-sm">
          <label htmlFor="polish-summary" className="font-medium text-gray-700">
            Professional Summary
          </label>
          <p className="text-gray-500">
            Enhance your professional summary to make it more impactful
          </p>
        </div>
      </div>
      
      <div className="flex items-start">
        <div className="flex items-center h-5">
          <input
            id="polish-experience"
            name="sections"
            type="checkbox"
            className="focus:ring-primary-500 h-4 w-4 text-primary-600 border-gray-300 rounded"
            checked={selectedSections.includes('experience')}
            onChange={() => handleSectionToggle('experience')}
          />
        </div>
        <div className="ml-3 text-sm">
          <label htmlFor="polish-experience" className="font-medium text-gray-700">
            Work Experience
          </label>
          <p className="text-gray-500">
            Improve descriptions of your work achievements and responsibilities
          </p>
        </div>
      </div>
      
      <div className="flex items-start">
        <div className="flex items-center h-5">
          <input
            id="polish-skills"
            name="sections"
            type="checkbox"
            className="focus:ring-primary-500 h-4 w-4 text-primary-600 border-gray-300 rounded"
            checked={selectedSections.includes('skills')}
            onChange={() => handleSectionToggle('skills')}
          />
        </div>
        <div className="ml-3 text-sm">
          <label htmlFor="polish-skills" className="font-medium text-gray-700">
            Skills
          </label>
          <p className="text-gray-500">
            Refine your skills section to highlight relevant abilities
          </p>
        </div>
      </div>
    </div>
  );
};

export default SectionSelector;